<div class="terms-wrapper">
  <div class="terms-container">
    <h1>
      KNOW YOUR CUSTOMER, ANTI-MONEY LAUNDERING, AND COMBATING FINANCING OF
      TERRORISM POLICY [KYC/AML/CFT POLICY]
    </h1>
    <p class="sub-text">
      <strong>Company:</strong> QUESTALIOUS PRIVATE LIMITED operating as
      COINWUSH
    </p>

    <p class="sub-text"><strong>Platform:</strong> Coinwush</p>
    <!-- <p class="sub-text">
      <strong>Registered Office:</strong> Meerut, Uttar Pradesh, India
    </p> -->

    <p class="sub-text"><strong>Version:</strong> 1.0</p>

    <p class="sub-text"><strong>Effective Date:</strong> {{ effectiveDate }}</p>
    <p class="sub-text"><strong>Last Revised:</strong> {{ lastUpdated }}</p>

    <!-- <section>
      <div class="aml-toc-card">
        <h2 class="toc-title">TABLE OF CONTENTS</h2>

        <ul class="toc-list">
          <li><a href="#introduction">1. Introduction</a></li>
          <li><a href="#definitions">2. Definitions</a></li>
          <li><a href="#scope">3. Scope and Applicability</a></li>

          <li class="toc-group">
            <span>4. Governance Framework</span>
            <ul>
              <li><a href="#board-oversight">4.1 Board Oversight</a></li>
              <li>
                <a href="#designated-director">4.2 Designated Director</a>
              </li>
              <li><a href="#principal-officer">4.3 Principal Officer</a></li>
            </ul>
          </li>

          <li>
            <a href="#customer-acceptance">5. Customer Acceptance Policy</a>
          </li>

          <li class="toc-group">
            <span>6. Customer Identification and Due Diligence</span>
            <ul>
              <li>
                <a href="#individual-customers">6.1 Individual Customers</a>
              </li>
              <li><a href="#legal-entities">6.2 Legal Entities</a></li>
              <li><a href="#enhanced-dd">6.3 Enhanced Due Diligence</a></li>
              <li><a href="#kyc-updation">6.4 Periodic KYC Updation</a></li>
            </ul>
          </li>

          <li class="toc-group">
            <span>7. Risk-Based Approach and Risk Management</span>
            <ul>
              <li>
                <a href="#enterprise-risk">7.1 Enterprise Risk Assessment</a>
              </li>
              <li>
                <a href="#risk-classification"
                  >7.2 Customer Risk Classification</a
                >
              </li>
              <li><a href="#risk-parameters">7.3 Risk Parameters</a></li>
            </ul>
          </li>

          <li class="toc-group">
            <span>8. Ongoing Due Diligence and Transaction Monitoring</span>
            <ul>
              <li>
                <a href="#continuous-monitoring">8.1 Continuous Monitoring</a>
              </li>
              <li>
                <a href="#transaction-monitoring"
                  >8.2 Transaction Monitoring Systems</a
                >
              </li>
              <li>
                <a href="#suspicious-identification"
                  >8.3 Suspicious Transaction Identification</a
                >
              </li>
            </ul>
          </li>

          <li>
            <a href="#sanctions">9. Sanctions Screening and PEP Controls</a>
          </li>
          <li><a href="#str">10. Suspicious Transaction Reporting</a></li>
          <li><a href="#record-keeping">11. Record Keeping</a></li>
          <li><a href="#training">12. Training and Awareness</a></li>
          <li><a href="#uapa">13. Compliance with UAPA and WMD Act</a></li>
          <li><a href="#review">14. Policy Review and Amendment</a></li>
          <li><a href="#annexures">15. Annexures</a></li>
        </ul>
      </div>
    </section> -->

    <section id="introduction" class="policy-section">
      <h2>1. INTRODUCTION</h2>

      <p>
        QUESTALIOUS PRIVATE LIMITED (hereinafter referred to as "the Company",
        "COINWUSH", "we", "us", or "our") operates a digital platform under the
        brand name "COINWUSH" that provides cash-settled derivatives trading
        services based on Virtual Digital Asset (VDA) price indices, including
        futures, perpetuals, and options contracts.
      </p>

      <p>
        All transactions on the COINWUSH platform are denominated and settled
        exclusively in Indian Rupees (INR). The Company does not facilitate the
        exchange, transfer, custody, or safekeeping of actual Virtual Digital
        Assets. Users engage solely in speculative trading of derivative
        contracts whose value is derived from VDA price movements, with all
        settlements occurring in fiat currency.
      </p>

      <p>
        The Company is committed to maintaining the highest standards of
        compliance with applicable Anti-Money Laundering (AML),
        Counter-Financing of Terrorism (CFT), and Counter-Proliferation
        Financing (CPF) regulations.
      </p>

      <p>
        This Know Your Customer, Anti-Money Laundering, and Combating Financing
        of Terrorism Policy (the "Policy") establishes a comprehensive framework
        for:
      </p>

      <ul class="policy-bullets">
        <li>
          Preventing the use of the COINWUSH platform for money laundering,
          terrorist financing, or proliferation financing activities
        </li>
        <li>
          Implementing robust customer identification, verification, and due
          diligence procedures
        </li>
        <li>
          Conducting ongoing monitoring and reporting of suspicious transactions
        </li>
        <li>
          Ensuring compliance with the PMLA, Prevention of Money Laundering
          (Maintenance of Records) Rules, 2005 (PML Rules), and guidelines
          issued by FIU-IND
        </li>
      </ul>

      <p>
        The Company adopts a zero-tolerance approach toward financial crime and
        has implemented risk-based controls, systems, and procedures designed to
        detect and prevent the misuse of its platform for illicit purposes.
      </p>

      <p>
        This Policy applies to all customers, employees, directors, and
        third-party service providers of the Company and shall be read in
        conjunction with the Company's Terms of Use, Privacy Policy, and other
        internal policies and procedures.
      </p>
    </section>

    <section id="definitions" class="policy-section">
      <h2>2. DEFINITIONS</h2>

      <p>
        For the purposes of this Policy, the following terms shall have the
        meanings assigned below:
      </p>

      <div class="definitions-list">
        <p>
          <strong>"Applicable Law"</strong> means all statutes, laws, rules,
          regulations, ordinances, directives, circulars, guidelines, orders,
          notifications, and instructions having the force of law in India,
          including but not limited to the Prevention of Money Laundering Act,
          2002, the Prevention of Money Laundering (Maintenance of Records)
          Rules, 2005, the Unlawful Activities (Prevention) Act, 1967, the
          Weapons of Mass Destruction and their Delivery Systems (Prohibition of
          Unlawful Activities) Act, 2005, guidelines issued by FIU-IND, and
          directions issued by CERT-In, as amended from time to time.
        </p>

        <p>
          <strong>"Beneficial Owner"</strong> means the natural person(s) who
          ultimately own or control a customer or on whose behalf a transaction
          is being conducted, including those who exercise ultimate effective
          control over a legal person or arrangement.
        </p>

        <p>
          <strong>"Customer" or "User" or "Client"</strong> means any individual
          or legal entity who has registered on the COINWUSH platform and
          engages in derivatives trading activities.
        </p>

        <p>
          <strong>"Customer Due Diligence (CDD)"</strong> means the process of
          identifying and verifying the identity of a Customer using reliable
          and independent sources of documents, data, or information,
          understanding the nature and purpose of the business relationship,
          assessing the Customer's risk profile, and conducting ongoing
          monitoring.
        </p>

        <p>
          <strong>"Derivatives"</strong> means financial contracts, including
          futures, perpetuals, and options, whose value is derived from the
          price movements of underlying Virtual Digital Assets, and which are
          cash-settled in Indian Rupees on the COINWUSH platform.
        </p>

        <p>
          <strong>"Designated Director"</strong> means the director designated
          by the Company in accordance with Rule 2(1)(ba) of the PML Rules who
          is responsible for ensuring overall compliance with obligations
          imposed under Chapter IV of the PMLA and the PML Rules.
        </p>

        <p>
          <strong>"Enhanced Due Diligence (EDD)"</strong> means additional due
          diligence measures applied to Customers or transactions assessed as
          high risk, including Politically Exposed Persons, customers from
          high-risk jurisdictions, or those engaged in complex or unusual
          transaction patterns.
        </p>

        <p>
          <strong>"Financial Intelligence Unit – India (FIU-IND)"</strong> means
          the national agency responsible for receiving, processing, analyzing,
          and disseminating information relating to suspect financial
          transactions under the PMLA, and designated as the regulator for
          Virtual Digital Asset Service Providers.
        </p>

        <p>
          <strong>"Officially Valid Document (OVD)"</strong> means the Passport,
          Driving License, proof of possession of Aadhaar Number, or Voter's
          Identity Card issued by the Election Commission of India, as notified
          under the PML Rules.
        </p>

        <p>
          <strong>"Politically Exposed Persons (PEPs)"</strong> means
          individuals who are or have been entrusted with prominent public
          functions in India or a foreign country, including heads of state or
          government, senior politicians, senior government, judicial or
          military officers, senior executives of state-owned corporations,
          important political party officials, and their immediate family
          members and close associates.
        </p>

        <p>
          <strong>"Principal Officer"</strong> means the officer designated by
          the Company under Rule 2(1)(f) of the PML Rules who is responsible for
          ensuring implementation and compliance with AML/CFT/CPF obligations,
          monitoring transactions, and furnishing information and reports to
          FIU-IND.
        </p>

        <p>
          <strong>"Reporting Entity (RE)"</strong> means COINWUSH, as registered
          with FIU-IND under the PMLA, and obligated to comply with AML/CFT/CPF
          requirements.
        </p>

        <p>
          <strong>"Risk-Based Approach (RBA)"</strong> means the methodology
          adopted by the Company to identify, assess, and mitigate money
          laundering, terrorist financing, and proliferation financing risks in
          proportion to the nature, scale, and complexity of customer
          relationships and transactions.
        </p>

        <p>
          <strong>"Suspicious Transaction Report (STR)"</strong> means a report
          filed by the Company with FIU-IND in respect of a transaction or
          series of transactions that raise reasonable grounds of suspicion of
          money laundering, terrorist financing, or proliferation financing.
        </p>

        <p>
          <strong>"Virtual Digital Assets (VDA)"</strong> means any information,
          code, number, or token (not being Indian or foreign currency),
          generated through cryptographic means or otherwise, as defined under
          Section 2(47A) of the Income Tax Act, 1961, which serves as the
          underlying reference for derivative contracts offered on the COINWUSH
          platform but is not held, transferred, or custodied by the Company.
        </p>
      </div>
    </section>

    <section id="scope" class="policy-section">
      <h2>3. SCOPE AND APPLICABILITY</h2>

      <p>
        This Policy applies to QUESTALIOUS PRIVATE LIMITED in its capacity as a
        Reporting Entity providing derivatives trading services related to
        Virtual Digital Assets, as notified under Notification S.O. 1072(E)
        dated March 07, 2023.
      </p>

      <h3 class="sub-heading">Key Clarifications on Business Model:</h3>

      <p>
        The Company operates a cash-settled derivatives trading platform with
        the following characteristics:
      </p>

      <div class="clarification-list">
        <div class="clarification-item">
          <h4>1. No VDA Custody:</h4>
          <p>
            The Company does not hold, store, custody, or safeguard any Virtual
            Digital Assets on behalf of customers.
          </p>
        </div>

        <div class="clarification-item">
          <h4>2. INR-Only Transactions:</h4>
          <p>
            All deposits, withdrawals, margin requirements, profit/loss
            settlements, and fees are denominated and transacted exclusively in
            Indian Rupees (INR).
          </p>
        </div>

        <div class="clarification-item">
          <h4>3. Derivatives Trading:</h4>
          <p>
            Customers trade futures, perpetuals, and options contracts based on
            VDA price indices. These contracts are financial instruments, not
            actual VDAs.
          </p>
        </div>

        <div class="clarification-item">
          <h4>4. Cash Settlement:</h4>
          <p>
            Upon contract expiry or closure, settlements are made in INR based
            on the applicable index price. No VDA is delivered or transferred.
          </p>
        </div>

        <div class="clarification-item">
          <h4>5. No VDA Transfers:</h4>
          <p>
            The Company does not facilitate, enable, or process any transfers of
            actual Virtual Digital Assets between customers or to/from external
            wallets.
          </p>
        </div>
      </div>

      <p>
        Notwithstanding the cash-settled nature of its services, the Company
        recognizes that it falls within the regulatory framework applicable to
        entities providing services related to Virtual Digital Assets and
        voluntarily adopts this comprehensive AML/CFT/CPF framework in
        accordance with FIU-IND guidelines.
      </p>

      <p>This Policy applies to:</p>

      <ul class="policy-bullets">
        <li>All customers onboarded on the COINWUSH platform</li>
        <li>All transactions conducted on the platform</li>
        <li>All employees, directors, and officers of the Company</li>
        <li>
          All third-party service providers engaged by the Company for KYC,
          compliance, or related functions
        </li>
      </ul>
    </section>

    <section id="governance-framework" class="policy-section">
      <h2>4. GOVERNANCE FRAMEWORK</h2>

      <!-- 4.1 Board Oversight -->
      <section id="board-oversight" class="sub-section">
        <h3>4.1 Board Oversight</h3>

        <p>
          The Board of Directors of QUESTALIOUS PRIVATE LIMITED bears ultimate
          responsibility for the establishment, implementation, and
          effectiveness of the Company's AML/CFT/CPF framework.
        </p>

        <p>The Board's responsibilities include:</p>

        <ul class="policy-bullets">
          <li>Approving this Policy and all material amendments thereto</li>
          <li>
            Ensuring that adequate resources, internal controls, systems, and
            trained personnel are in place to effectively manage money
            laundering, terrorist financing, and proliferation financing risks
          </li>
          <li>
            Reviewing the effectiveness of the AML/CFT/CPF program at least
            annually
          </li>
          <li>
            Providing strategic direction and oversight of compliance activities
          </li>
          <li>
            Reviewing reports submitted by the Principal Officer regarding
            suspicious transaction reporting, regulatory communications, and
            compliance status
          </li>
        </ul>

        <p>
          The Board or a designated Committee of the Board shall review
          AML/CFT/CPF matters at least annually, and more frequently where
          warranted by risk profile, regulatory developments, or material
          incidents.
        </p>
      </section>

      <!-- 4.2 Designated Director -->
      <section id="designated-director" class="sub-section">
        <h3>4.2 Designated Director</h3>

        <p>
          The Company has appointed a Designated Director in accordance with
          Rule 2(1)(ba) of the PML Rules. The Designated Director is a person
          designated by the Board who is responsible for ensuring overall
          compliance with the obligations imposed under Chapter IV of the PMLA
          and the PML Rules.
        </p>

        <p>Responsibilities of the Designated Director:</p>

        <ol class="policy-numbered">
          <li>
            Ensure the establishment and maintenance of internal mechanisms for
            adherence to procedures relating to:
            <ul class="policy-sub-bullets">
              <li>Maintenance of records under Rule 5 of the PML Rules</li>
              <li>Furnishing of information under Rule 7 of the PML Rules</li>
              <li>
                Submission of prescribed reports under Rule 3 of the PML Rules
              </li>
              <li>
                Conduct of risk assessments under Rule 9(13) of the PML Rules
              </li>
            </ul>
          </li>

          <li>
            Oversee the Company's compliance with record-keeping, customer due
            diligence, transaction monitoring, reporting, and training
            requirements
          </li>

          <li>
            Ensure that adequate resources and controls support statutory
            compliance
          </li>

          <li>
            Act as the point of escalation for significant AML/CFT/CPF matters
          </li>

          <li>Liaise with regulatory authorities as required</li>
        </ol>

        <p>
          The details of the Designated Director, including name, designation,
          address, and contact information, are communicated to FIU-IND and
          updated through the FINGate portal as required under Rule 7(1) of the
          PML Rules.
        </p>
      </section>

      <!-- 4.3 Principal Officer -->
      <section id="principal-officer" class="sub-section">
        <h3>4.3 Principal Officer</h3>

        <p>
          The Company has appointed a Principal Officer in accordance with Rule
          2(1)(f) of the PML Rules. The Principal Officer is a senior
          management-level official, based in India, exclusively engaged with
          the Company on a full-time basis for AML/CFT/CPF compliance.
        </p>

        <p><strong>Qualifications and Requirements:</strong></p>

        <ul class="policy-bullets">
          <li>
            Management-level position, preferably not below the level of Head of
            Compliance/Risk
          </li>
          <li>
            Minimum three years of relevant experience in AML/CFT compliance or
            financial services regulation
          </li>
          <li>
            Thorough knowledge of money laundering, terrorist financing, and
            proliferation financing risks
          </li>
          <li>
            Seniority, independence, and authority to discharge responsibilities
            effectively
          </li>
          <li>Full-time engagement with the Company</li>
        </ul>

        <p>Responsibilities of the Principal Officer:</p>

        <ol class="policy-numbered">
          <li>
            Ensure implementation and ongoing compliance with AML/CFT/CPF
            obligations under Chapter IV of the PMLA and the PML Rules
          </li>

          <li>
            Monitor transactions on a continuous basis and establish systems for
            detecting suspicious transactions
          </li>

          <li>
            Furnish information to FIU-IND as required under Rule 7(2) and Rule
            8(2) of the PML Rules, including Suspicious Transaction Reports
          </li>

          <li>
            Act as the primary point of contact with FIU-IND, law enforcement
            agencies, and other regulatory authorities
          </li>

          <li>
            Maintain records of analysis, investigation, and decision-making
            regarding suspicious transactions
          </li>

          <li>
            Ensure timely and accurate reporting of suspicious and attempted
            suspicious transactions to FIU-IND
          </li>

          <li>
            Review and approve escalated alerts from the AML monitoring team
          </li>

          <li>
            Report directly to the Board or a designated Board Committee on
            AML/CFT/CPF matters at least annually
          </li>

          <li>Oversee the AML/CFT training program</li>

          <li>
            Respond promptly to requests for information from FIU-IND and law
            enforcement authorities
          </li>
        </ol>

        <p>
          The Principal Officer and the Designated Director are separate
          individuals. The details of the Principal Officer, including name,
          designation, address, and contact details, are communicated to FIU-IND
          and updated through the FINGate portal as required under Rule 7(1) of
          the PML Rules.
        </p>
      </section>
    </section>

    <section id="customer-acceptance" class="policy-section">
      <h2>5. CUSTOMER ACCEPTANCE POLICY</h2>

      <p>
        The Company has adopted a comprehensive Customer Acceptance Policy to
        ensure that it establishes and maintains business relationships only
        with customers whose identity, background, and risk profile are
        consistent with applicable AML/CFT/CPF laws and regulatory expectations.
      </p>

      <h3 class="sub-heading">Core Principles:</h3>

      <!-- 5.1 -->
      <section id="no-anonymous" class="sub-section">
        <h3>5.1 No Anonymous or Fictitious Accounts</h3>

        <p>
          The Company does not open, operate, or maintain accounts in anonymous,
          fictitious, or benami names. All customers must be identifiable
          through proper Customer Due Diligence procedures.
        </p>
      </section>

      <!-- 5.2 -->
      <section id="verification-precondition" class="sub-section">
        <h3>5.2 Verification as Precondition</h3>

        <p>No customer shall be permitted to:</p>

        <ul class="policy-bullets">
          <li>Deposit funds</li>
          <li>Execute trades</li>
          <li>Utilize any services on the COINWUSH platform</li>
        </ul>

        <p>
          until Customer Due Diligence requirements have been satisfactorily
          completed and the customer has been approved for onboarding.
        </p>
      </section>

      <!-- 5.3 -->
      <section id="sanctions-screening" class="sub-section">
        <h3>5.3 Sanctions Screening</h3>

        <p>
          Prior to onboarding, all customers are screened against applicable
          sanctions lists, including:
        </p>

        <ul class="policy-bullets">
          <li>United Nations Security Council (UNSC) sanctions lists</li>
          <li>
            Lists issued under the Unlawful Activities (Prevention) Act, 1967
            (UAPA)
          </li>
          <li>
            Lists issued under the Weapons of Mass Destruction and their
            Delivery Systems (Prohibition of Unlawful Activities) Act, 2005 (WMD
            Act)
          </li>
          <li>Office of Foreign Assets Control (OFAC) sanctions lists</li>
          <li>Other watchlists and adverse media databases</li>
        </ul>

        <p>
          Customers whose names, or whose beneficial owners' names, match
          entries on sanctions lists shall not be onboarded. Existing
          relationships shall be terminated immediately upon identification of a
          sanctions match.
        </p>
      </section>

      <!-- 5.4 -->
      <section id="refusal-termination" class="sub-section">
        <h3>5.4 Refusal or Termination of Relationships</h3>

        <p>
          The Company reserves the right to refuse to establish, or to
          terminate, a customer relationship where:
        </p>

        <ul class="policy-bullets">
          <li>
            The customer fails to provide required information or documentation
          </li>
          <li>
            The customer provides false, misleading, non-genuine, or
            unverifiable information
          </li>
          <li>The customer is uncooperative with verification requests</li>
          <li>Appropriate Customer Due Diligence measures cannot be applied</li>
          <li>
            The customer is identified as a Politically Exposed Person and
            Enhanced Due Diligence cannot be satisfactorily completed
          </li>
          <li>
            The customer is assessed as posing unacceptable money laundering,
            terrorist financing, or proliferation financing risk
          </li>
          <li>Sanctions screening identifies a positive match</li>
          <li>The customer engages in suspicious or prohibited activities</li>
        </ul>
      </section>

      <!-- 5.5 -->
      <section id="prohibited-customers" class="sub-section">
        <h3>5.5 Prohibited Customer Categories</h3>

        <p>
          The Company shall not establish or maintain relationships with
          customers who are:
        </p>

        <ol class="policy-numbered">
          <li>
            Associated with terrorism, terrorist financing, or organized crime
          </li>

          <li>
            Engaged in activities prohibited under Indian law, including but not
            limited to:
            <ul class="policy-sub-bullets">
              <li>
                Trafficking in narcotics, drugs, weapons, or prohibited goods
              </li>
              <li>
                Wildlife trafficking or trafficking in human beings, human
                organs, or tissues
              </li>
              <li>Fraud, embezzlement, or corruption</li>
              <li>Child pornography, exploitation, or abuse</li>
              <li>Counterfeiting of currency, bank notes, or products</li>
              <li>Infringement of intellectual property rights</li>
              <li>Money laundering or proceeds of crime</li>
            </ul>
          </li>

          <li>
            Located in jurisdictions identified as high-risk or non-cooperative
            by the Financial Action Task Force (FATF) or FIU-IND, where Enhanced
            Due Diligence cannot be satisfactorily applied
          </li>

          <li>
            Entities or individuals subject to sanctions under applicable laws
          </li>

          <li>
            Offering financial services without appropriate authorization or
            licensing
          </li>
        </ol>
      </section>

      <!-- 5.6 -->
      <section id="risk-based-acceptance" class="sub-section">
        <h3>5.6 Risk-Based Acceptance</h3>

        <p>
          Customer acceptance decisions are made on a risk-based approach. The
          Company applies appropriate due diligence measures commensurate with
          the assessed risk of each customer.
        </p>
      </section>
    </section>

    <section id="customer-identification" class="policy-section">
      <h2>6. CUSTOMER IDENTIFICATION AND DUE DILIGENCE</h2>

      <p>
        The Company implements robust Customer Due Diligence (CDD) procedures to
        verify the identity of all customers, understand the nature and purpose
        of the business relationship, assess risk profiles, and conduct ongoing
        monitoring.
      </p>

      <!-- 6.1 -->
      <section id="individual-customers" class="sub-section">
        <h3>6.1 Individual Customers</h3>

        <h4>6.1.1 Mandatory Information Collection</h4>

        <p>
          For individual customers, the Company collects and verifies the
          following minimum information at the time of onboarding:
        </p>

        <h5>Personal Information:</h5>
        <ul class="policy-bullets">
          <li>Full name (as appearing in PAN)</li>
          <li>Date of birth</li>
          <li>Gender</li>
          <li>Nationality</li>
          <li>Permanent Account Number (PAN)</li>
        </ul>

        <h5>Contact Details:</h5>
        <ul class="policy-bullets">
          <li>Residential address</li>
          <li>Mobile number</li>
          <li>Email address</li>
        </ul>

        <h5>Financial and Occupation Details:</h5>
        <ul class="policy-bullets">
          <li>Occupation</li>
          <li>Income range</li>
          <li>Source of funds</li>
          <li>Bank account details (for deposit and withdrawal purposes)</li>
        </ul>

        <h5>Additional Parameters:</h5>
        <ul class="policy-bullets">
          <li>Selfie photograph with liveness detection</li>
          <li>
            Geo-location coordinates (latitude and longitude) at the time of
            onboarding, along with date, timestamp, and IP address
          </li>
        </ul>

        <h4>6.1.2 Document Requirements</h4>

        <p>
          The Company requires the following documents from individual
          customers:
        </p>

        <p><strong>Mandatory:</strong></p>
        <ol class="policy-numbered">
          <li>
            Permanent Account Number (PAN) issued by the Income Tax Department
          </li>
          <li>
            One Officially Valid Document (OVD) containing proof of identity and
            address:
            <ul class="policy-sub-bullets">
              <li>Aadhaar Card (proof of possession of Aadhaar Number)</li>
              <li>Passport</li>
              <li>Driving License</li>
              <li>
                Voter's Identity Card issued by the Election Commission of India
              </li>
            </ul>
          </li>
        </ol>

        <p><strong>In Case of Address Discrepancy:</strong></p>

        <p>
          If the OVD does not contain the customer's current residential
          address, one of the following documents (not more than two months old)
          shall be obtained:
        </p>

        <ul class="policy-bullets">
          <li>Utility bills (electricity, water, gas, landline telephone)</li>
          <li>Bank account statement</li>
          <li>Property or municipal tax receipt</li>
        </ul>

        <h4>6.1.3 Verification Process</h4>

        <p>The Company verifies customer information and documents through:</p>

        <ol class="policy-numbered">
          <li>
            PAN Verification: Real-time verification against Income Tax
            Department database
          </li>
          <li>
            Document Verification: Verification of identity documents using
            secure verification services such as DigiLocker or equivalent
            third-party verification platforms
          </li>
          <li>
            Liveness Detection: Capturing a live selfie photograph of the
            customer using liveness detection technology to ensure the
            individual is physically present during onboarding
          </li>
          <li>
            Geo-Location Capture: Recording the latitude and longitude
            coordinates, date, timestamp, and IP address at the time of
            onboarding
          </li>
          <li>
            Mobile and Email Verification: One-Time Password (OTP) validation
            for mobile number and email address
          </li>
          <li>
            Bank Account Verification: Penny-drop verification mechanism to
            confirm ownership and operational status of the customer's linked
            bank account
          </li>
        </ol>

        <p>
          In cases where discrepancies are identified between the address
          provided and geo-location data, Enhanced Due Diligence measures shall
          be applied.
        </p>
      </section>

      <!-- 6.2 -->
      <section id="legal-entities" class="sub-section">
        <h3>6.2 Legal Entities</h3>

        <p>
          The Company currently does not onboard legal entities, trusts,
          non-profit organizations, or other non-natural persons as customers.
          This exclusion is in place to maintain strict adherence to risk-based
          KYC/AML standards and regulatory compliance protocols.
        </p>

        <p>
          Should the Company's customer base expand in the future to include
          corporate or institutional clients, this Policy will be updated to
          include appropriate procedures for legal entity onboarding in
          accordance with applicable regulations, including:
        </p>

        <ul class="policy-bullets">
          <li>Collection of incorporation documents</li>
          <li>
            Identification and verification of directors, authorized
            signatories, and beneficial owners
          </li>
          <li>Verification of ownership and control structures</li>
          <li>Enhanced measures for high-risk legal persons</li>
        </ul>
      </section>

      <!-- 6.3 -->
      <section id="enhanced-due-diligence" class="sub-section">
        <h3>6.3 Enhanced Due Diligence</h3>

        <h4>6.3.1 Triggers for Enhanced Due Diligence</h4>

        <p>EDD is mandatorily applied in the following circumstances:</p>

        <ol class="policy-numbered">
          <li>
            Politically Exposed Persons (PEPs): Customers identified as PEPs, or
            their immediate family members or close associates
          </li>
          <li>
            High-Risk Jurisdictions: Customers with connections to countries or
            jurisdictions designated as high-risk or non-cooperative by FATF,
            FIU-IND, or subject to sanctions
          </li>
          <li>
            Non-Profit Organizations: If onboarded in the future, all NPOs will
            be subject to EDD and registration on the DARPAN Portal as required
            under Rule 9(9A) of the PML Rules
          </li>
          <li>
            Complex or Unusual Transactions: Customers engaged in transaction
            patterns that are complex, unusually large, or have no apparent
            economic or lawful purpose
          </li>
          <li>
            Adverse Media or Screening Hits: Customers flagged through adverse
            media screening or watchlist checks
          </li>
          <li>
            Geographic Risk: Customers whose declared address does not match
            geo-location data captured during onboarding
          </li>
          <li>
            Source of Funds Concerns: Customers unable to satisfactorily explain
            the source or legitimacy of funds
          </li>
        </ol>

        <h4>6.3.2 Enhanced Due Diligence Measures</h4>

        <p>EDD measures include, but are not limited to:</p>

        <ol class="policy-numbered">
          <li>
            Additional Documentation:
            <ul class="policy-sub-bullets">
              <li>
                Bank statements or financial records to verify source of funds
              </li>
              <li>Income tax returns</li>
              <li>Employment or business proof</li>
              <li>Wealth declarations</li>
            </ul>
          </li>

          <li>
            Enhanced Verification:
            <ul class="policy-sub-bullets">
              <li>
                Independent verification of information from public or credible
                databases
              </li>
              <li>
                Background checks and research to validate identity and
                legitimacy
              </li>
            </ul>
          </li>

          <li>
            Purpose and Intent:
            <ul class="policy-sub-bullets">
              <li>
                Detailed inquiry into the purpose of the business relationship
              </li>
              <li>
                Understanding the intended nature and volume of transactions
              </li>
              <li>Justification for specific transactions or patterns</li>
            </ul>
          </li>

          <li>
            Source of Wealth and Funds:
            <ul class="policy-sub-bullets">
              <li>
                Documenting and verifying the origin of the customer's assets
                and income
              </li>
              <li>Understanding the economic rationale for transactions</li>
            </ul>
          </li>

          <li>
            Increased Monitoring:
            <ul class="policy-sub-bullets">
              <li>More frequent reviews of account activity</li>
              <li>Lower thresholds for transaction monitoring alerts</li>
              <li>Enhanced scrutiny of withdrawal requests</li>
            </ul>
          </li>

          <li>
            Senior Management Approval:
            <ul class="policy-sub-bullets">
              <li>
                For Politically Exposed Persons, approval from the Designated
                Director or Principal Officer is required prior to onboarding or
                continuing the relationship
              </li>
            </ul>
          </li>

          <li>
            Ongoing Review:
            <ul class="policy-sub-bullets">
              <li>
                More frequent periodic KYC updates (every six months for
                high-risk customers)
              </li>
            </ul>
          </li>
        </ol>

        <p>
          Where the Company is unable to complete Enhanced Due Diligence
          satisfactorily, the customer relationship shall be refused or
          terminated, and a Suspicious Transaction Report may be filed with
          FIU-IND.
        </p>
      </section>

      <!-- 6.4 -->
      <section id="periodic-kyc" class="sub-section">
        <h3>6.4 Periodic KYC Updation</h3>

        <p>
          The Company conducts periodic review and updation of Customer Due
          Diligence information to ensure that all data remains accurate,
          current, and relevant.
        </p>

        <h4>Frequency of KYC Updation:</h4>

        <table class="risk-table">
          <thead>
            <tr>
              <th>Risk Category</th>
              <th>Review Frequency</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>High Risk</td>
              <td>Every 6 months</td>
            </tr>
            <tr>
              <td>Medium Risk</td>
              <td>Every 12 months (annually)</td>
            </tr>
            <tr>
              <td>Low Risk</td>
              <td>Every 24 months (2 years)</td>
            </tr>
          </tbody>
        </table>

        <p>
          The review period is measured from the date of account opening or the
          last KYC updation, whichever is later.
        </p>

        <h4>KYC Updation Process:</h4>

        <ol class="policy-numbered">
          <li>
            No Change in Information:
            <ul class="policy-sub-bullets">
              <li>
                If there is no change in the customer's CDD information, a
                self-declaration shall be obtained from the customer confirming
                that all information on record remains unchanged
              </li>
              <li>
                The self-declaration is dated, stored, and recorded in the
                Company's systems
              </li>
            </ul>
          </li>

          <li>
            Change in Information:
            <ul class="policy-sub-bullets">
              <li>
                If there is any change in the customer's name, address,
                occupation, income, or other CDD data, the Company shall
                undertake the CDD process equivalent to that applicable for
                onboarding a new customer, including verification of updated
                documents
              </li>
            </ul>
          </li>

          <li>
            Expired Documents:
            <ul class="policy-sub-bullets">
              <li>
                If any CDD document (such as Aadhaar, Passport, or Driving
                License) has expired, the customer shall be required to submit
                updated, valid documents
              </li>
              <li>
                The Company shall undertake fresh verification of such documents
              </li>
            </ul>
          </li>

          <li>
            Prompt Update in Systems:
            <ul class="policy-sub-bullets">
              <li>
                All updated information and documents are promptly recorded in
                the Company's systems
              </li>
              <li>
                A clear record of the date of CDD updation and nature of changes
                is maintained
              </li>
            </ul>
          </li>
        </ol>

        <h4>Customer Obligations:</h4>

        <p>
          Customers are advised and required to promptly inform the Company of
          any changes in the information or documents submitted at the time of
          onboarding or during subsequent KYC updates.
        </p>

        <p>
          Non-compliance with periodic KYC updation requirements may result in
          restrictions on account usage, suspension of trading privileges, or
          termination of the customer relationship, in accordance with
          Applicable Law.
        </p>
      </section>
    </section>

    <section id="risk-based-approach" class="policy-section">
      <h2>7. RISK-BASED APPROACH AND RISK MANAGEMENT</h2>

      <p>
        The Company adopts a comprehensive Risk-Based Approach (RBA) to
        identify, assess, mitigate, and manage money laundering (ML), terrorist
        financing (TF), and proliferation financing (PF) risks.
      </p>

      <!-- 7.1 -->
      <section id="enterprise-risk-assessment" class="sub-section">
        <h3>7.1 Enterprise Risk Assessment</h3>

        <p>
          The Company conducts a structured, documented enterprise-wide risk
          assessment to identify areas where its products, services, customers,
          delivery channels, and technologies may be exposed to ML/TF/PF risks.
        </p>

        <h4>Scope of Risk Assessment:</h4>

        <p>The assessment considers, inter alia:</p>

        <ul class="policy-bullets">
          <li>
            Risks arising from derivatives trading based on Virtual Digital
            Assets
          </li>
          <li>Customer profiles and risk characteristics</li>
          <li>Transaction structures, patterns, volumes, and values</li>
          <li>Geographic exposure of customers and transactions</li>
          <li>Use of technology and digital onboarding</li>
          <li>Exposure to high-risk jurisdictions</li>
          <li>Emerging typologies and regulatory guidance</li>
        </ul>

        <h4>Frequency:</h4>

        <p>
          The enterprise-wide risk assessment is conducted at least annually.
          The interval between any two assessments shall not exceed one year.
        </p>

        <h4>Product and Service Risk Assessment:</h4>

        <p>
          Prior to the launch of any new products, services, features, or
          technologies, or material changes to existing offerings, the Company
          undertakes a specific risk assessment to identify, assess, and
          mitigate any additional ML/TF/PF risks that may arise.
        </p>

        <h4>Documentation and Oversight:</h4>

        <p>
          The risk assessment is documented in detail and is proportionate to
          the nature, size, complexity, and structure of the Company's business.
          The results of the assessment, along with identified mitigation
          measures, are:
        </p>

        <ul class="policy-bullets">
          <li>Reviewed and approved by the Board of Directors</li>
          <li>
            Made available to FIU-IND and other competent authorities upon
            request
          </li>
        </ul>
      </section>

      <!-- 7.2 -->
      <section id="customer-risk-classification" class="sub-section">
        <h3>7.2 Customer Risk Classification</h3>

        <p>
          The Company applies a documented risk-based framework to categorize
          customers based on their assessed ML/TF/PF risk.
        </p>

        <h4>Risk Categories:</h4>

        <p>Customers are classified into the following risk categories:</p>

        <ol class="policy-numbered">
          <li>Low Risk</li>
          <li>Medium Risk</li>
          <li>High Risk</li>
        </ol>

        <p>
          The Company may develop additional sub-categories or apply more
          granular segmentation where a higher risk perception warrants enhanced
          scrutiny.
        </p>

        <h4>Risk Classification Principles:</h4>

        <ul class="policy-bullets">
          <li>
            Risk classification is based on a holistic assessment of multiple
            parameters (see Section 7.3)
          </li>
          <li>Parameters are objectively defined and consistently applied</li>
          <li>
            Risk classification is not static and is subject to periodic review
          </li>
          <li>
            Risk classification is confidential and is not disclosed to
            customers
          </li>
        </ul>

        <h4>Application of Risk-Based Controls:</h4>

        <p>
          The level of due diligence, monitoring, and review applied to each
          customer is proportionate to the assigned risk category:
        </p>

        <ul class="policy-bullets">
          <li>
            Low Risk: Standard CDD measures, periodic KYC updation every 24
            months, routine transaction monitoring
          </li>
          <li>
            Medium Risk: Standard CDD measures, periodic KYC updation every 12
            months, standard transaction monitoring
          </li>
          <li>
            High Risk: Enhanced Due Diligence, periodic KYC updation every 6
            months, enhanced transaction monitoring with lower alert thresholds
          </li>
        </ul>
      </section>

      <!-- 7.3 -->
      <section id="risk-parameters" class="sub-section">
        <h3>7.3 Risk Parameters</h3>

        <p>
          Customer risk classification is undertaken based on the following
          parameters:
        </p>

        <h4>For Individual Customers:</h4>

        <ol class="policy-numbered">
          <li>
            Customer Background:
            <ul class="policy-sub-bullets">
              <li>Age and demographic profile</li>
              <li>Employment status and occupation type</li>
              <li>Professional background and industry association</li>
            </ul>
          </li>

          <li>
            Geographic Factors:
            <ul class="policy-sub-bullets">
              <li>Place of residence</li>
              <li>Nationality</li>
              <li>Alignment between declared address and geo-location data</li>
              <li>Exposure to high-risk or sanctioned jurisdictions</li>
            </ul>
          </li>

          <li>
            Financial Profile:
            <ul class="policy-sub-bullets">
              <li>Income range and source of income</li>
              <li>Source of funds for trading</li>
              <li>Transaction volumes and values</li>
            </ul>
          </li>

          <li>
            Nature of Activity:
            <ul class="policy-sub-bullets">
              <li>Purpose of using the platform</li>
              <li>Trading behavior and patterns</li>
              <li>Use of leverage</li>
            </ul>
          </li>

          <li>
            Screening Results:
            <ul class="policy-sub-bullets">
              <li>PEP status</li>
              <li>Sanctions screening results</li>
              <li>Adverse media hits</li>
            </ul>
          </li>

          <li>
            Behavioral Indicators:
            <ul class="policy-sub-bullets">
              <li>Frequency and timing of transactions</li>
              <li>Rapid movement of funds</li>
              <li>Unusual trading patterns</li>
              <li>Use of VPNs or proxy services to obscure origin</li>
            </ul>
          </li>
        </ol>

        <h4>High-Risk Indicators:</h4>

        <p>
          Customers are automatically classified as high risk if they exhibit
          one or more of the following characteristics:
        </p>

        <ul class="policy-bullets">
          <li>
            Politically Exposed Persons (PEPs) or their family members or close
            associates
          </li>
          <li>
            Adverse Media: Negative news, legal cases, or public association
            with financial crime, fraud, or terrorism
          </li>
          <li>
            Sanctioned or High-Risk Jurisdictions: Residence in or links to
            countries designated by FATF, FIU-IND, or under sanctions
          </li>
          <li>
            Anomalous Trading Patterns: High volume transactions inconsistent
            with declared income, occupation, or source of funds
          </li>
          <li>
            Rapid Movement of Funds: Frequent deposits and withdrawals with
            minimal trading activity
          </li>
          <li>Unverifiable Source of Funds</li>
          <li>
            Use of Obfuscation Techniques: Use of VPNs, proxies, TOR networks,
            or other tools to obscure geographic origin or identity
          </li>
          <li>
            High Leverage Usage: Persistent use of maximum leverage levels
            inconsistent with risk profile
          </li>
        </ul>

        <h4>Periodic Review:</h4>

        <p>
          Customer risk classification is reviewed at a periodicity of at least
          once every six months, or earlier where triggered by:
        </p>

        <ul class="policy-bullets">
          <li>Changes in customer behavior or transaction patterns</li>
          <li>Internal monitoring alerts</li>
          <li>Adverse media screening hits</li>
          <li>Regulatory developments or guidance</li>
          <li>At the discretion of the Compliance Team</li>
        </ul>

        <p>
          Where a review results in a change to a customer's risk category, the
          applicable due diligence and monitoring measures are updated without
          undue delay.
        </p>
      </section>
    </section>

    <section id="ongoing-due-diligence" class="policy-section">
      <h2>8. ONGOING DUE DILIGENCE AND TRANSACTION MONITORING</h2>

      <p>
        The Company conducts ongoing due diligence and transaction monitoring
        throughout the lifecycle of the customer relationship to ensure that
        activity remains consistent with the customer's profile and to detect
        potential ML/TF/PF activities.
      </p>

      <!-- 8.1 -->
      <section id="continuous-monitoring" class="sub-section">
        <h3>8.1 Continuous Monitoring</h3>

        <p>
          In accordance with Rule 9(12) of the PML Rules, the Company exercises
          ongoing due diligence by closely examining and scrutinizing
          transactions on a continuous basis to determine whether:
        </p>

        <ul class="policy-bullets">
          <li>
            Customer transactions are consistent with the Company's knowledge of
            the customer
          </li>
          <li>
            Transaction activity aligns with the customer's financial/risk
            profile
          </li>
          <li>Transactions are consistent with the declared source of funds</li>
          <li>
            Changes in the customer's risk profile necessitate enhanced measures
            under CDD
          </li>
        </ul>

        <p>
          Ongoing due diligence also involves identifying changes in customer
          behavior, transaction patterns, or profile that may necessitate
          reassessment of risk classification or application of Enhanced Due
          Diligence.
        </p>
      </section>

      <!-- 8.2 -->
      <section id="transaction-monitoring-systems" class="sub-section">
        <h3>8.2 Transaction Monitoring Systems</h3>

        <p>
          The Company has established and maintains a comprehensive transaction
          monitoring framework that operates on a continuous basis and is
          designed to identify suspicious transactions.
        </p>

        <h4>Monitoring Scope:</h4>

        <p>
          Transaction monitoring applies to all activities on the COINWUSH
          platform, including:
        </p>

        <ul class="policy-bullets">
          <li>Fiat deposits (INR)</li>
          <li>Fiat withdrawals (INR)</li>
          <li>Derivatives trades (open, close, liquidation)</li>
          <li>Margin movements</li>
          <li>Profit and loss settlements</li>
          <li>Fee payments</li>
        </ul>

        <h4>Monitoring Approach:</h4>

        <p>
          The Company deploys automated transaction monitoring systems supported
          by manual review. These systems:
        </p>

        <ul class="policy-bullets">
          <li>Operate in real-time or near-real-time</li>
          <li>
            Generate alerts based on predefined rules, thresholds, and
            behavioral patterns
          </li>
          <li>
            Incorporate red flag indicators, typologies, and guidance issued by
            FIU-IND
          </li>
          <li>
            Utilize risk scoring models and machine learning where appropriate
          </li>
          <li>
            Are calibrated to the scale, size, and complexity of the Company's
            operations
          </li>
        </ul>

        <h4>Red Flag Indicators:</h4>

        <p>
          The Company's monitoring systems incorporate red flag indicators
          including, but not limited to:
        </p>

        <ol class="policy-numbered">
          <li>
            Structuring:
            <ul class="policy-sub-bullets">
              <li>
                Multiple deposits or withdrawals just below reporting thresholds
              </li>
              <li>
                Fragmentation of transactions with no apparent economic
                rationale
              </li>
            </ul>
          </li>

          <li>
            Rapid Movement of Funds:
            <ul class="policy-sub-bullets">
              <li>
                Deposits followed by immediate withdrawals with minimal trading
                activity
              </li>
              <li>Frequent round-tripping of funds</li>
            </ul>
          </li>

          <li>
            Inconsistent Activity:
            <ul class="policy-sub-bullets">
              <li>
                Transaction volumes or values inconsistent with customer
                profile, occupation, or declared income
              </li>
              <li>Sudden, unexplained spikes in trading activity</li>
            </ul>
          </li>

          <li>
            Unusual Patterns:
            <ul class="policy-sub-bullets">
              <li>Trading patterns with no apparent economic rationale</li>
              <li>Sustained losses without corresponding change in behavior</li>
              <li>
                Unusual timing of transactions (e.g., late-night bulk deposits)
              </li>
            </ul>
          </li>

          <li>
            Geographic Risk:
            <ul class="policy-sub-bullets">
              <li>
                Transactions involving customers from high-risk jurisdictions
              </li>
              <li>Use of VPNs or proxies to obscure geographic location</li>
            </ul>
          </li>

          <li>
            New Device or Access Point:
            <ul class="policy-sub-bullets">
              <li>
                New device logins followed by immediate large transactions
              </li>
            </ul>
          </li>

          <li>
            Multiple Bank Accounts:
            <ul class="policy-sub-bullets">
              <li>Deposits from multiple bank accounts</li>
              <li>
                Withdrawals to different bank accounts than those used for
                deposits
              </li>
            </ul>
          </li>
        </ol>

        <h4>Alert Management:</h4>

        <p>All alerts generated by the transaction monitoring system are:</p>

        <ul class="policy-bullets">
          <li>Promptly reviewed by the AML/CFT Compliance Team</li>
          <li>
            Investigated using customer KYC data, transaction history, and
            behavioral analysis
          </li>
          <li>
            Escalated to the Principal Officer where suspicion is established
          </li>
          <li>Documented with investigation notes and decisions</li>
          <li>
            Reported to FIU-IND as Suspicious Transaction Reports where
            warranted
          </li>
        </ul>

        <p>
          The Principal Officer has ultimate authority for determining whether a
          transaction is suspicious and whether an STR should be filed.
        </p>
      </section>

      <!-- 8.3 -->
      <section id="suspicious-transaction-identification" class="sub-section">
        <h3>8.3 Suspicious Transaction Identification</h3>

        <p>A transaction is deemed suspicious if it:</p>

        <ol class="policy-numbered">
          <li>
            Gives rise to reasonable grounds of suspicion that it may involve
            proceeds of an offence specified in the Schedule to the PMLA,
            regardless of value
          </li>
          <li>
            Appears to be made in circumstances of unusual or unjustified
            complexity
          </li>
          <li>Appears to have no economic rationale or bona fide purpose</li>
          <li>
            Gives rise to reasonable grounds of suspicion that it may involve
            financing of activities relating to terrorism
          </li>
        </ol>

        <h4>Investigation and Decision-Making:</h4>

        <p>Where a transaction is flagged as potentially suspicious:</p>

        <ul class="policy-bullets">
          <li>The Compliance Team conducts a detailed investigation</li>
          <li>
            All available information is reviewed, including KYC records,
            transaction logs, customer communications, and behavioral insights
          </li>
          <li>The investigation is documented with clear reasoning</li>
          <li>
            The matter is escalated to the Principal Officer for final
            determination
          </li>
          <li>
            The Principal Officer records reasons for treating the transaction
            as suspicious or non-reportable
          </li>
        </ul>

        <p>
          The ultimate analysis and decision-making responsibility rests with
          the Principal Officer, although preparatory and investigative tasks
          may be delegated within the Compliance Team.
        </p>
      </section>
    </section>

    <section id="sanctions-screening" class="policy-section">
      <h2>9. SANCTIONS SCREENING AND PEP CONTROLS</h2>

      <p>
        The Company conducts comprehensive sanctions screening and Politically
        Exposed Person (PEP) checks to identify and mitigate risks associated
        with sanctioned individuals, entities, and jurisdictions.
      </p>

      <!-- Sanctions Lists -->
      <section id="sanctions-lists" class="sub-section">
        <h3>Sanctions Lists:</h3>

        <p>
          The Company screens customers and transactions against the following
          sanctions lists and databases:
        </p>

        <ol class="policy-numbered">
          <li>United Nations Security Council (UNSC) sanctions lists</li>
          <li>
            Lists issued under the Unlawful Activities (Prevention) Act, 1967
            (UAPA)
          </li>
          <li>
            Lists issued under the Weapons of Mass Destruction and their
            Delivery Systems (Prohibition of Unlawful Activities) Act, 2005 (WMD
            Act)
          </li>
          <li>Office of Foreign Assets Control (OFAC) sanctions lists (US)</li>
          <li>Financial Action Task Force (FATF) high-risk jurisdictions</li>
          <li>FIU-IND advisories and watchlists</li>
          <li>Other applicable international and domestic watchlists</li>
        </ol>
      </section>

      <!-- PEP Databases -->
      <section id="pep-databases" class="sub-section">
        <h3>PEP Databases:</h3>

        <p>
          The Company screens customers against reputable PEP databases to
          identify:
        </p>

        <ul class="policy-bullets">
          <li>Politically Exposed Persons</li>
          <li>Immediate family members of PEPs</li>
          <li>Close associates of PEPs</li>
        </ul>
      </section>

      <!-- Screening Frequency -->
      <section id="screening-frequency" class="sub-section">
        <h3>Screening Frequency:</h3>

        <p>Sanctions and PEP screening is conducted:</p>

        <ol class="policy-numbered">
          <li>At Onboarding: Prior to account activation</li>
          <li>
            Ongoing Basis: Periodic automated screening against updated lists
          </li>
          <li>
            Upon Change in KYC Details: When customer information is updated
          </li>
          <li>
            Upon Change in Sanctions Lists: When new sanctions are issued or
            lists are updated
          </li>
          <li>
            Prior to Material Transactions: For high-value or high-risk
            transactions
          </li>
        </ol>
      </section>

      <!-- Screening Tools -->
      <section id="screening-tools" class="sub-section">
        <h3>Screening Tools:</h3>

        <p>
          The Company utilizes automated screening tools and reputable
          third-party service providers for sanctions and PEP screening. These
          tools provide:
        </p>

        <ul class="policy-bullets">
          <li>Real-time screening capabilities</li>
          <li>Automatic updates when sanctions lists change</li>
          <li>Configurable matching algorithms to reduce false positives</li>
          <li>Audit trails and documentation</li>
        </ul>
      </section>

      <!-- Actions Upon Positive Match -->
      <section id="positive-match-actions" class="sub-section">
        <h3>Actions Upon Positive Match:</h3>

        <p>
          Where a customer or transaction is identified as matching a sanctions
          list or PEP database:
        </p>

        <ol class="policy-numbered">
          <li>
            Sanctions Match:
            <ul class="policy-sub-bullets">
              <li>
                The transaction or onboarding process is immediately suspended
              </li>
              <li>
                The match is reviewed by the Compliance Team to confirm or
                dismiss the hit
              </li>
              <li>
                If confirmed, the customer relationship is refused or terminated
              </li>
              <li>
                Funds are frozen in accordance with applicable legal
                requirements
              </li>
              <li>
                Reporting is made to FIU-IND and other competent authorities as
                required
              </li>
            </ul>
          </li>

          <li>
            PEP Match:
            <ul class="policy-sub-bullets">
              <li>Enhanced Due Diligence is applied</li>
              <li>
                Senior management approval (Designated Director or Principal
                Officer) is obtained before establishing or continuing the
                relationship
              </li>
              <li>
                Enhanced monitoring is applied with lower alert thresholds
              </li>
              <li>Periodic KYC is conducted every six months</li>
            </ul>
          </li>
        </ol>
      </section>

      <!-- Adverse Media Screening -->
      <section id="adverse-media-screening" class="sub-section">
        <h3>Adverse Media Screening:</h3>

        <p>
          The Company conducts adverse media screening at onboarding and on an
          ongoing basis to identify customers with potential involvement in:
        </p>

        <ul class="policy-bullets">
          <li>Fraud or financial crime</li>
          <li>Terrorism or terrorist financing</li>
          <li>Money laundering</li>
          <li>Corruption or bribery</li>
          <li>Other illicit activities</li>
        </ul>

        <p>
          Adverse media hits are escalated to the Compliance Team for review and
          potential Enhanced Due Diligence.
        </p>
      </section>
    </section>

    <section id="suspicious-transaction-reporting" class="policy-section">
      <h2>10. SUSPICIOUS TRANSACTION REPORTING</h2>

      <p>
        The Company identifies and reports suspicious and attempted suspicious
        transactions in accordance with the PMLA, PML Rules, and FIU-IND
        guidance.
      </p>

      <!-- Reporting Obligation -->
      <section id="reporting-obligation" class="sub-section">
        <h3>Reporting Obligation:</h3>

        <p>
          Pursuant to Rule 7(2) and Rule 8(2) read with Rule 3(1)(D) of the PML
          Rules, the Company files Suspicious Transaction Reports (STRs) with
          FIU-IND in respect of:
        </p>

        <ul class="policy-bullets">
          <li>
            Transactions that give rise to reasonable grounds of suspicion of
            money laundering, terrorist financing, or proliferation financing
          </li>
          <li>
            Attempted suspicious transactions, including abandoned or aborted
            transactions where the customer was asked to provide details or
            documents and declined to proceed
          </li>
        </ul>
      </section>

      <!-- STR Filing Threshold -->
      <section id="str-filing-threshold" class="sub-section">
        <h3>STR Filing Threshold:</h3>

        <p>
          STRs are filed irrespective of the value or amount of the transaction,
          if reasonable grounds for suspicion exist.
        </p>
      </section>

      <!-- Timeline -->
      <section id="timeline-for-filing" class="sub-section">
        <h3>Timeline for Filing:</h3>

        <p>
          STRs are filed with FIU-IND promptly, and in any event within seven
          (7) working days from the date on which the Principal Officer is
          satisfied that the transaction is suspicious.
        </p>
      </section>

      <!-- STR Process -->
      <section id="str-process" class="sub-section">
        <h3>STR Process:</h3>

        <ol class="policy-numbered">
          <li>
            Detection:
            <ul class="policy-sub-bullets">
              <li>
                Suspicious activity is detected through transaction monitoring
                alerts, manual escalations, customer support flags, or adverse
                media screening
              </li>
            </ul>
          </li>

          <li>
            Initial Review:
            <ul class="policy-sub-bullets">
              <li>
                The Compliance Team conducts an initial review of the flagged
                transaction
              </li>
              <li>
                Relevant information is gathered, including KYC data,
                transaction history, and behavioral analysis
              </li>
            </ul>
          </li>

          <li>
            Investigation:
            <ul class="policy-sub-bullets">
              <li>
                A detailed investigation is conducted, documented with
                investigation notes, evidence, and analysis
              </li>
              <li>
                The matter is escalated to the Principal Officer if suspicion
                persists
              </li>
            </ul>
          </li>

          <li>
            Decision:
            <ul class="policy-sub-bullets">
              <li>
                The Principal Officer reviews the investigation and makes the
                final determination on whether to file an STR
              </li>
              <li>
                Reasons for the decision (whether to file or not to file) are
                clearly documented and retained
              </li>
            </ul>
          </li>

          <li>
            STR Filing:
            <ul class="policy-sub-bullets">
              <li>
                If an STR is warranted, it is filed electronically with FIU-IND
                via the FINnet gateway
              </li>
              <li>
                The STR includes complete and accurate information as prescribed
                by FIU-IND, including:
                <ul class="policy-sub-bullets">
                  <li>Customer KYC details</li>
                  <li>
                    Transaction details (nature, amount, date, counterparties)
                  </li>
                  <li>Grounds for suspicion</li>
                  <li>Supporting documentation and narrative</li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            Record Keeping:
            <ul class="policy-sub-bullets">
              <li>
                A record of the STR filing and all related investigation
                materials is retained securely for at least five (5) years
              </li>
            </ul>
          </li>
        </ol>
      </section>

      <!-- STR Quality -->
      <section id="str-quality" class="sub-section">
        <h3>STR Quality:</h3>

        <p>
          The Company is committed to filing high-quality STRs that provide
          FIU-IND with actionable intelligence. This includes:
        </p>

        <ul class="policy-bullets">
          <li>
            Leveraging all available data points (KYC, transactional,
            technical/metadata, IP addresses, device IDs, behavioral insights)
          </li>
          <li>
            Providing clear, detailed narratives explaining the basis for
            suspicion
          </li>
          <li>Including relevant supporting evidence and documentation</li>
        </ul>
      </section>

      <!-- Confidentiality -->
      <section id="confidentiality-tipping-off" class="sub-section">
        <h3>Confidentiality and Tipping-Off Prohibition:</h3>

        <p>
          Pursuant to Section 12(2), Section 12A(3) of the PMLA, and Rule 8(6)
          of the PML Rules, the Company, its directors, officers, and all
          employees (permanent and contractual) are strictly prohibited from
          disclosing ("tipping off") that an STR or related information has been
          reported or provided to FIU-IND.
        </p>

        <p>This prohibition on tipping off extends:</p>

        <ul class="policy-bullets">
          <li>Before the filing of the STR</li>
          <li>During the preparation and filing of the STR</li>
          <li>After the submission of the STR</li>
        </ul>

        <p>There is no tipping off to the customer at any level.</p>

        <p>
          All STR-related information is handled with strict confidentiality,
          and internal access is restricted to designated compliance officers
          and senior management on a need-to-know basis.
        </p>
      </section>
    </section>

    <section id="suspicious-transaction-reporting" class="policy-section">
      <h2>10. SUSPICIOUS TRANSACTION REPORTING</h2>

      <p>
        The Company identifies and reports suspicious and attempted suspicious
        transactions in accordance with the PMLA, PML Rules, and FIU-IND
        guidance.
      </p>

      <!-- 10.1 Reporting Obligation -->
      <section id="reporting-obligation" class="sub-section">
        <h3>Reporting Obligation:</h3>

        <p>
          Pursuant to Rule 7(2) and Rule 8(2) read with Rule 3(1)(D) of the PML
          Rules, the Company files Suspicious Transaction Reports (STRs) with
          FIU-IND in respect of:
        </p>

        <ul class="policy-bullets">
          <li>
            Transactions that give rise to reasonable grounds of suspicion of
            money laundering, terrorist financing, or proliferation financing
          </li>
          <li>
            Attempted suspicious transactions, including abandoned or aborted
            transactions where the customer was asked to provide details or
            documents and declined to proceed
          </li>
        </ul>
      </section>

      <!-- 10.2 STR Filing Threshold -->
      <section id="str-filing-threshold" class="sub-section">
        <h3>STR Filing Threshold:</h3>

        <p>
          STRs are filed irrespective of the value or amount of the transaction,
          if reasonable grounds for suspicion exist.
        </p>
      </section>

      <!-- 10.3 Timeline for Filing -->
      <section id="timeline-for-filing" class="sub-section">
        <h3>Timeline for Filing:</h3>

        <p>
          STRs are filed with FIU-IND promptly, and in any event within seven
          (7) working days from the date on which the Principal Officer is
          satisfied that the transaction is suspicious.
        </p>
      </section>

      <!-- 10.4 STR Process -->
      <section id="str-process" class="sub-section">
        <h3>STR Process:</h3>

        <ol class="policy-numbered">
          <li>
            <strong>Detection:</strong>
            <ul class="policy-sub-bullets">
              <li>
                Suspicious activity is detected through transaction monitoring
                alerts, manual escalations, customer support flags, or adverse
                media screening
              </li>
            </ul>
          </li>

          <li>
            <strong>Initial Review:</strong>
            <ul class="policy-sub-bullets">
              <li>
                The Compliance Team conducts an initial review of the flagged
                transaction
              </li>
              <li>
                Relevant information is gathered, including KYC data,
                transaction history, and behavioral analysis
              </li>
            </ul>
          </li>

          <li>
            <strong>Investigation:</strong>
            <ul class="policy-sub-bullets">
              <li>
                A detailed investigation is conducted, documented with
                investigation notes, evidence, and analysis
              </li>
              <li>
                The matter is escalated to the Principal Officer if suspicion
                persists
              </li>
            </ul>
          </li>

          <li>
            <strong>Decision:</strong>
            <ul class="policy-sub-bullets">
              <li>
                The Principal Officer reviews the investigation and makes the
                final determination on whether to file an STR
              </li>
              <li>
                Reasons for the decision (whether to file or not to file) are
                clearly documented and retained
              </li>
            </ul>
          </li>

          <li>
            <strong>STR Filing:</strong>
            <ul class="policy-sub-bullets">
              <li>
                If an STR is warranted, it is filed electronically with FIU-IND
                via the FINnet gateway
              </li>
              <li>
                The STR includes complete and accurate information as prescribed
                by FIU-IND, including:
                <ul class="policy-sub-bullets">
                  <li>Customer KYC details</li>
                  <li>
                    Transaction details (nature, amount, date, counterparties)
                  </li>
                  <li>Grounds for suspicion</li>
                  <li>Supporting documentation and narrative</li>
                </ul>
              </li>
            </ul>
          </li>

          <li>
            <strong>Record Keeping:</strong>
            <ul class="policy-sub-bullets">
              <li>
                A record of the STR filing and all related investigation
                materials is retained securely for at least five (5) years
              </li>
            </ul>
          </li>
        </ol>
      </section>

      <!-- 10.5 STR Quality -->
      <section id="str-quality" class="sub-section">
        <h3>STR Quality:</h3>

        <p>
          The Company is committed to filing high-quality STRs that provide
          FIU-IND with actionable intelligence. This includes:
        </p>

        <ul class="policy-bullets">
          <li>
            Leveraging all available data points (KYC, transactional,
            technical/metadata, IP addresses, device IDs, behavioral insights)
          </li>
          <li>
            Providing clear, detailed narratives explaining the basis for
            suspicion
          </li>
          <li>Including relevant supporting evidence and documentation</li>
        </ul>
      </section>

      <!-- 10.6 Confidentiality and Tipping-Off Prohibition -->
      <section id="confidentiality-tipping-off" class="sub-section">
        <h3>Confidentiality and Tipping-Off Prohibition:</h3>

        <p>
          Pursuant to Section 12(2), Section 12A(3) of the PMLA, and Rule 8(6)
          of the PML Rules, the Company, its directors, officers, and all
          employees (permanent and contractual) are strictly prohibited from
          disclosing ("tipping off") that an STR or related information has been
          reported or provided to FIU-IND.
        </p>

        <p>This prohibition on tipping off extends:</p>

        <ul class="policy-bullets">
          <li>Before the filing of the STR</li>
          <li>During the preparation and filing of the STR</li>
          <li>After the submission of the STR</li>
        </ul>

        <p>There is no tipping off to the customer at any level.</p>

        <p>
          All STR-related information is handled with strict confidentiality,
          and internal access is restricted to designated compliance officers
          and senior management on a need-to-know basis.
        </p>
      </section>
    </section>

    <section id="training-and-awareness" class="policy-section">
      <h2>12. TRAINING AND AWARENESS</h2>

      <p>
        The Company implements a comprehensive training and awareness program to
        ensure that all employees understand and comply with AML/CFT/CPF
        obligations.
      </p>

      <!-- Scope of Training -->
      <section id="scope-of-training" class="sub-section">
        <h3>Scope of Training:</h3>

        <p>Training is provided to:</p>

        <ul class="policy-bullets">
          <li>All new employees at the time of joining (induction training)</li>
          <li>
            All existing employees on a periodic basis (refresher training)
          </li>
          <li>
            Employees in frontline, compliance, risk, audit, and customer
            support roles (role-based training)
          </li>
        </ul>
      </section>

      <!-- Training Content -->
      <section id="training-content" class="sub-section">
        <h3>Training Content:</h3>

        <p>The training program covers:</p>

        <ol class="policy-numbered">
          <li>
            Overview of the Prevention of Money Laundering Act, 2002 and PML
            Rules
          </li>
          <li>
            Understanding of money laundering, terrorist financing, and
            proliferation financing typologies
          </li>
          <li>The Company's KYC/AML/CFT Policy and procedures</li>
          <li>
            Customer Due Diligence and Enhanced Due Diligence requirements
          </li>
          <li>Risk-based approach and customer risk classification</li>
          <li>
            Transaction monitoring and identification of suspicious transactions
          </li>
          <li>Red flag indicators specific to derivatives trading</li>
          <li>Suspicious Transaction Reporting procedures and timelines</li>
          <li>Prohibition on tipping-off and confidentiality requirements</li>
          <li>Sanctions screening and PEP controls</li>
          <li>UAPA and WMD Act compliance</li>
          <li>Record-keeping obligations</li>
          <li>Recent trends, regulatory updates, and FIU-IND guidance</li>
        </ol>
      </section>

      <!-- Training Frequency -->
      <section id="training-frequency" class="sub-section">
        <h3>Training Frequency:</h3>

        <ul class="policy-bullets">
          <li>
            Induction Training: All new employees must complete AML/CFT training
            within thirty (30) days of commencement of employment
          </li>
          <li>
            Refresher Training: All employees must complete refresher training
            at least annually
          </li>
          <li>
            Ad-Hoc Training: Additional training is provided whenever there are
            material changes in regulations, policies, or identified compliance
            gaps
          </li>
        </ul>
      </section>

      <!-- Training Methodology -->
      <section id="training-methodology" class="sub-section">
        <h3>Training Methodology:</h3>

        <p>Training is delivered through:</p>

        <ul class="policy-bullets">
          <li>Online learning modules</li>
          <li>Webinars or in-person sessions</li>
          <li>Case studies and practical scenarios</li>
          <li>Assessments or quizzes to demonstrate understanding</li>
        </ul>
      </section>

      <!-- Training Records -->
      <section id="training-records" class="sub-section">
        <h3>Training Records:</h3>

        <p>The Company maintains records of:</p>

        <ul class="policy-bullets">
          <li>Training completion by each employee</li>
          <li>Assessment results</li>
          <li>Attendance records</li>
          <li>Training materials and content</li>
        </ul>
      </section>

      <!-- Recruitment Screening -->
      <section id="recruitment-screening" class="sub-section">
        <h3>Recruitment Screening:</h3>

        <p>
          The Company has implemented adequate screening mechanisms as an
          integral part of the recruitment process to ensure high standards and
          to prevent hiring individuals with criminal backgrounds or who lack
          requisite knowledge of compliance and regulatory requirements.
        </p>
      </section>
    </section>

    <section id="uapa-wmd-compliance" class="policy-section">
      <h2>13. COMPLIANCE WITH UAPA AND WMD ACT</h2>

      <p>
        The Company ensures strict compliance with obligations under the
        Unlawful Activities (Prevention) Act, 1967 (UAPA) and the Weapons of
        Mass Destruction and their Delivery Systems (Prohibition of Unlawful
        Activities) Act, 2005 (WMD Act).
      </p>

      <!-- 13.1 UAPA Compliance -->
      <section id="uapa-compliance" class="sub-section">
        <h3>13.1 UAPA Compliance</h3>

        <h4>Section 51A of UAPA:</h4>

        <p>
          Pursuant to Section 51A of UAPA, the Company ensures that it does not
          have any accounts or relationships with individuals or entities
          appearing in the lists of individuals and entities suspected of having
          terrorist links, which are approved by and periodically circulated by
          the United Nations Security Council (UNSC).
        </p>

        <h4>Implementation:</h4>

        <p>The Company has implemented the following measures:</p>

        <ol class="policy-numbered">
          <li>
            Maintain Updated Lists:
            <ul class="policy-sub-bullets">
              <li>
                The Designated List under UAPA is maintained and updated without
                delay in accordance with notifications and orders issued by the
                Ministry of Home Affairs (MHA)
              </li>
            </ul>
          </li>

          <li>
            Screening:
            <ul class="policy-sub-bullets">
              <li>
                All customers are screened against the Designated List at the
                time of onboarding and on an ongoing basis
              </li>
            </ul>
          </li>

          <li>
            Freezing of Funds:
            <ul class="policy-sub-bullets">
              <li>
                In case of a match with the Designated List, the customer
                account is immediately frozen, and no transactions are permitted
              </li>
            </ul>
          </li>

          <li>
            Reporting to Central Nodal Officer:
            <ul class="policy-sub-bullets">
              <li>
                Full particulars of the frozen funds, financial assets, or
                economic resources are immediately reported to the Central Nodal
                Officer (FIU-IND) without delay
              </li>
            </ul>
          </li>

          <li>
            STR Filing:
            <ul class="policy-sub-bullets">
              <li>
                A Suspicious Transaction Report is filed with FIU-IND covering
                all transactions in the accounts that match the Designated List
              </li>
            </ul>
          </li>
        </ol>

        <h4>Procedure for Implementation:</h4>

        <p>The Company complies with the procedure outlined in:</p>

        <ul class="policy-bullets">
          <li>Order dated February 02, 2021 (Ministry of Home Affairs)</li>
          <li>Gazette Notification dated June 08, 2021</li>
          <li>Corrigendums dated March 15, 2023, and April 22, 2024</li>
        </ul>

        <p>
          The list of Nodal Officers for UAPA is maintained and updated based on
          information available on the website of the Ministry of Home Affairs.
        </p>
      </section>

      <!-- 13.2 WMD Act Compliance -->
      <section id="wmd-act-compliance" class="sub-section">
        <h3>13.2 WMD Act Compliance</h3>

        <h4>Section 12A of WMD Act:</h4>

        <p>
          The Company complies with the procedure for implementation of Section
          12A of the Weapons of Mass Destruction and their Delivery Systems
          (Prohibition of Unlawful Activities) Act, 2005, as detailed in the
          Order dated January 30, 2023 (F. No. P-12011/14/2022-ES Cell-DOR)
          issued by the Ministry of Finance.
        </p>

        <h4>Implementation:</h4>

        <ol class="policy-numbered">
          <li>
            Maintain Designated List:
            <ul class="policy-sub-bullets">
              <li>
                The list of individuals and entities designated under the WMD
                Act is maintained and updated without delay
              </li>
            </ul>
          </li>

          <li>
            Screening:
            <ul class="policy-sub-bullets">
              <li>
                Customers are screened against the WMD Designated List at
                onboarding and on an ongoing basis
              </li>
            </ul>
          </li>

          <li>
            Prevent Transactions:
            <ul class="policy-sub-bullets">
              <li>
                Where a customer's particulars match the Designated List, the
                Company immediately prevents such individuals or entities from
                conducting financial transactions
              </li>
            </ul>
          </li>

          <li>
            Reporting to Central Nodal Officer:
            <ul class="policy-sub-bullets">
              <li>
                Full particulars of funds, financial assets, or economic
                resources held by matched individuals/entities are immediately
                reported to the Central Nodal Officer (FIU-IND) without delay
              </li>
            </ul>
          </li>

          <li>
            Suspicious Transaction Reporting:
            <ul class="policy-sub-bullets">
              <li>
                An STR is filed with FIU-IND covering all transactions in the
                accounts covered under the WMD Act
              </li>
            </ul>
          </li>

          <li>
            Exemptions and Inadvertent Freezing:
            <ul class="policy-sub-bullets">
              <li>
                The Company complies with provisions regarding exemptions from
                freezing orders and procedures for inadvertent freezing of
                accounts as may be applicable
              </li>
            </ul>
          </li>
        </ol>
      </section>
    </section>

    <section id="travel-rule-compliance" class="policy-section">
      <h2>14. TRAVEL RULE COMPLIANCE SECTION</h2>

      <p>
        Given that COINWUSH does not facilitate any actual VDA transfers—neither
        from customers to the platform, nor from the platform to customers, nor
        between customers—the Travel Rule requirements as specified in Rule 4 of
        the PML Rules are NOT APPLICABLE to COINWUSH's current business
        operations.
      </p>

      <p>
        The Company's activities are limited to providing cash-settled financial
        derivatives based on VDA price movements. These derivatives are
        financial instruments, not Virtual Digital Assets themselves, and their
        settlement does not involve any VDA transfer or delivery.
      </p>
    </section>

    <section id="policy-review-and-amendment" class="policy-section">
      <h2>15. POLICY REVIEW AND AMENDMENT</h2>

      <p>
        This Policy is reviewed and updated to ensure continued alignment with:
      </p>

      <ul class="policy-bullets">
        <li>Applicable laws and regulations</li>
        <li>FIU-IND guidelines and directions</li>
        <li>
          Emerging money laundering, terrorist financing, and proliferation
          financing risks
        </li>
        <li>Supervisory expectations and best practices</li>
      </ul>

      <!-- Review Frequency -->
      <section id="review-frequency" class="sub-section">
        <h3>Review Frequency:</h3>

        <p>This Policy is reviewed:</p>

        <ul class="policy-bullets">
          <li>At least once every twelve (12) months (annually)</li>
          <li>
            More frequently if prompted by:
            <ul class="policy-sub-bullets">
              <li>Material changes in applicable laws or regulations</li>
              <li>FIU-IND guidance or directives</li>
              <li>Significant compliance findings or audit observations</li>
              <li>
                Changes in the Company's business model, products, or services
              </li>
              <li>Emerging risks identified through risk assessments</li>
            </ul>
          </li>
        </ul>
      </section>

      <!-- Approval -->
      <section id="approval" class="sub-section">
        <h3>Approval:</h3>

        <p>
          All material amendments to this Policy require approval by the Board
          of Directors of QUESTALIOUS PRIVATE LIMITED.
        </p>
      </section>

      <!-- Communication -->
      <section id="communication" class="sub-section">
        <h3>Communication:</h3>

        <p>Amended versions of this Policy are:</p>

        <ul class="policy-bullets">
          <li>Communicated to all employees</li>
          <li>
            Made prominently available on the Company's website and mobile
            application
          </li>
          <li>Provided to customers as part of onboarding and upon request</li>
        </ul>
      </section>

      <!-- Version Control -->
      <section id="version-control" class="sub-section">
        <h3>Version Control:</h3>

        <p>The Company maintains version control of this Policy, including:</p>

        <ul class="policy-bullets">
          <li>Version number</li>
          <li>Date of approval</li>
          <li>Summary of changes</li>
          <li>Effective date</li>
        </ul>
      </section>
    </section>

    <section id="annexures" class="policy-section">
      <h2>16. ANNEXURES</h2>

      <!-- Annexure A -->
      <section id="annexure-a" class="sub-section">
        <h3>Annexure A: Red Flag Indicators for Derivatives Trading</h3>

        <p>
          The following are indicative red flags specific to derivatives trading
          activities:
        </p>

        <ol class="policy-numbered">
          <li>
            Structuring and Layering:
            <ul class="policy-sub-bullets">
              <li>
                Multiple deposits or withdrawals in amounts just below reporting
                thresholds
              </li>
              <li>Rapid movement of funds with minimal trading activity</li>
            </ul>
          </li>

          <li>
            Inconsistent Trading Behavior:
            <ul class="policy-sub-bullets">
              <li>
                Trading volumes or leverage usage inconsistent with customer
                profile or declared income
              </li>
              <li>Sudden, unexplained changes in trading patterns</li>
            </ul>
          </li>

          <li>
            Economic Irrationality:
            <ul class="policy-sub-bullets">
              <li>
                Sustained trading losses with no change in behavior or strategy
              </li>
              <li>
                Transactions with no apparent economic or investment rationale
              </li>
            </ul>
          </li>

          <li>
            Geographic Risk:
            <ul class="policy-sub-bullets">
              <li>
                Use of VPNs, proxies, or TOR networks to obscure geographic
                location
              </li>
              <li>Customers from high-risk or sanctioned jurisdictions</li>
            </ul>
          </li>

          <li>
            Multiple Bank Accounts:
            <ul class="policy-sub-bullets">
              <li>
                Deposits from multiple bank accounts not previously disclosed
              </li>
              <li>
                Withdrawals to bank accounts different from those used for
                deposits
              </li>
            </ul>
          </li>

          <li>
            Rapid Round-Tripping:
            <ul class="policy-sub-bullets">
              <li>
                Deposits followed by immediate withdrawals with minimal or no
                trading
              </li>
            </ul>
          </li>

          <li>
            High-Risk Instruments:
            <ul class="policy-sub-bullets">
              <li>
                Exclusive use of highly leveraged or high-risk derivative
                products without commensurate financial capacity
              </li>
            </ul>
          </li>

          <li>
            Unusual Timing:
            <ul class="policy-sub-bullets">
              <li>
                Bulk deposits or withdrawals at unusual hours (late night, early
                morning)
              </li>
              <li>
                Transactions timed to coincide with regulatory reporting
                deadlines
              </li>
            </ul>
          </li>

          <li>
            Non-Cooperation:
            <ul class="policy-sub-bullets">
              <li>
                Reluctance or refusal to provide source of funds information
              </li>
              <li>Providing false or misleading information</li>
              <li>Avoiding contact or communication with the Company</li>
            </ul>
          </li>

          <li>
            New Devices and Immediate Large Transactions:
            <ul class="policy-sub-bullets">
              <li>
                New device login followed by immediate large deposit or
                withdrawal
              </li>
            </ul>
          </li>
        </ol>

        <p>
          These indicators are not exhaustive and are used in conjunction with
          customer profiling, transaction history, and other contextual
          information to identify suspicious activity.
        </p>
      </section>
    </section>

    <!-- <hr class="policy-divider" />

    <h3 class="center-text">END OF POLICY</h3>

    <hr class="policy-divider" /> -->

    <!-- <section id="acknowledgment-and-acceptance" class="policy-section">
      <h2>ACKNOWLEDGMENT AND ACCEPTANCE</h2>

      <p>
        This Know Your Customer, Anti-Money Laundering, and Combating Financing
        of Terrorism Policy has been approved by the Board of Directors of
        QUESTALIOUS PRIVATE LIMITED.
      </p>

      <h4>Approved by:</h4>

      <div class="signature-block">
        <p>________________________________________</p>
        <p>[Name]</p>
        <p>Designated Director</p>
        <p>QUESTALIOUS PRIVATE LIMITED</p>
        <p>Date: _______________</p>
      </div>

      <br />

      <div class="signature-block">
        <p>________________________________________</p>
        <p>[Name]</p>
        <p>Principal Officer</p>
        <p>QUESTALIOUS PRIVATE LIMITED</p>
        <p>Date: _______________</p>
      </div>
    </section> -->

    <!-- <hr class="policy-divider" /> -->

    <!-- <section id="official-use" class="policy-section">
      <h3>FOR OFFICIAL USE:</h3>

      <ul class="policy-bullets">
        <li>FIU-IND Registration Number: [To be filled upon registration]</li>
        <li>Policy Version: 1.0</li>
        <li>Next Review Date: [Date - within 12 months of effective date]</li>
      </ul>
    </section> -->

    <!-- <hr class="policy-divider" /> -->

    <div class="acknowledgment-box">
      <p>
        <strong>
          This Know Your Customer, Anti-Money Laundering, and Combating
          Financing of Terrorism Policy has been approved by the Board of
          Directors of QUESTALIOUS PRIVATE LIMITED.
        </strong>
      </p>
    </div>

    <!-- <div class="footer-note">
      <p>
        Questalious Private Limited | CIN: U63119UP2025PTC222413<br />
        155/101, Gali No. 7, Hari Nagar, Kankerkhera, Meerut – 250001, Uttar
        Pradesh, India<br />
        Website: https://coinwush.com | Support: support&#64;coinwush.com
      </p>
    </div> -->
  </div>
</div>
